import { StringObj } from "../../../type";

export const reviewTypeValues: StringObj[] = [
  // { id: "", label: "入力フォーマット（空白・不正値）" },
  // { id: "10", label: "フォーマット自動修正" },
  { id: "questionType", label: "回答形式" },
  { id: "questionText", label: "設問文" },
  { id: "whole", label: "全体設計" },
  { id: "option", label: "選択肢" },
  // { id: "5", label: "選択肢（優先度低）" },
  { id: "random", label: "ランダマイズ" },
  { id: "condition", label: "表示条件" },
];

export const reveiewComands: StringObj[] = [
  { id: "1", label: "チェックする" },
  { id: "2", label: "メモする" },
  { id: "3", label: "無視する" },
  { id: "4", label: "..." },
];

export const checkModes = ["new", "import"];
export const checkStateValues: StringObj = { excel: "Excelチェック", llm: "LLMチェック" };
